import { render, staticRenderFns } from "./IzinProyekViewEmail.vue?vue&type=template&id=e4abfecc&scoped=true&lang=pug&"
import script from "./IzinProyekViewEmail.vue?vue&type=script&lang=js&"
export * from "./IzinProyekViewEmail.vue?vue&type=script&lang=js&"
import style0 from "./IzinProyekViewEmail.vue?vue&type=style&index=0&id=e4abfecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4abfecc",
  null
  
)

export default component.exports